import { RepresentationRecord } from "./RepresentationRecord";

/**
 * Shadow of the CanonicalDataType enum in the roboto package.
 *
 * N.b.: if adding a type to this enum,
 * you **MUST** update any corresponding JSON schema declared in `shared/state/visualization/schema`
 * that exhaustively lists all CanonicalDataType values.
 */
export enum CanonicalDataType {
  Array = "array",
  Boolean = "boolean",
  Byte = "byte",
  Categorical = "categorical",
  Image = "image",
  Number = "number",
  NumberArray = "number_array",
  Object = "object",
  String = "string",
  Timestamp = "timestamp",
  Unknown = "unknown",

  // Special purpose types for data that represents geographic points
  LatDegFloat = "latdegfloat",
  LonDegFloat = "londegfloat",
  LatDegInt = "latdegint",
  LonDegInt = "londegint",
}

/**
 * Shadow of the MessagePathMetadataWellKnown enum in the roboto package.
 */
export enum MessagePathMetadataWellKnown {
  ColumnName = "column_name",
  Categories = "categories",
  Unit = "unit",
}

export interface MessagePathRecord {
  canonical_data_type: CanonicalDataType;
  created: string; // timestamp
  created_by: string;
  data_type: string;
  message_path: string;
  message_path_id: string;
  metadata: Record<string, unknown>;
  modified: string; // timestamp
  modified_by: string;
  representations: RepresentationRecord[];
  topic_id: string;
}

export enum MessagePathPartType {
  Attr = "Attr",
  Slice = "Slice",
}

export interface MessagePathAttr {
  type: MessagePathPartType.Attr;
  attribute: string;
  dataType: CanonicalDataType;
}

export interface MessagePathSlice {
  type: MessagePathPartType.Slice;
  start: number;
  end?: number | null;
}

export type MessagePathPart = MessagePathAttr | MessagePathSlice;

export function isMessagePathAttr(part: unknown): part is MessagePathAttr {
  return (
    typeof part === "object" &&
    part !== null &&
    "type" in part &&
    part.type === MessagePathPartType.Attr
  );
}

export interface MessagePathRepresentationMapping {
  message_paths: MessagePathRecord[];
  representation: RepresentationRecord;
}
